import { render, staticRenderFns } from "./ProductAddAttribute.vue?vue&type=template&id=50e29420&scoped=true&"
import script from "./ProductAddAttribute.vue?vue&type=script&lang=js&"
export * from "./ProductAddAttribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e29420",
  null
  
)

export default component.exports